import script from "./ChangeAdjustForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeAdjustForm.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeAdjustForm.vue?vue&type=style&index=0&id=125e3aa8&lang=scss"

const __exports__ = script;

export default __exports__